module.exports = __webpack_public_path__ + "static/media/gallery-door-open.d26a758b.png";